<template>
    <b-form-group :label="formLabel"
                  :label-for="textAreaId">
      <b-form-textarea :id="inputId"
                       v-model="formObject.ids"
                       :rows="textAreaRows">
      </b-form-textarea>
      <div class="invalid" :style="{visibility: showError ? 'visible' : 'hidden'}">
        <span class="error-message">
          {{errorMessage}}
        </span>
      </div>
    </b-form-group>
</template>

<script>
import { util } from '../../util/groups-mixin';

export default {
  name: 'AddRolesFormGroup',
  mixins: [util],
  props: {
    /* The backing form object */
    formObject: {
      type: Object,
      required: true,
    },
    /* The type of role represented. One of [administrators, managers, contacts, viewers] */
    roleType: {
      type: String,
      required: true,
      default: 'members',
    },
    /* The kind of role represented. One of [person, group, service] */
    roleKind: {
      type: String,
      required: true,
    },
    /* Optional ID for the textArea input field. One will be generated by default. */
    textAreaId: {
      type: String,
      required: false,
    },
    /* Optional form label. One will be generated by default based on the required props. */
    label: {
      type: String,
      required: false,
    },
    /* Optional number of rows the textArea will expand. Defaults to 3. */
    textAreaRows: {
      type: Number,
      required: false,
      default: 3,
    },
    /* Min length of input into the textArea for use as validation property. Defaults to 3. */
    idMinLength: {
      type: Number,
      required: false,
      default: 3,
    },
    /* Optional start to validation error message. A default will be generated. */
    errorStart: {
      type: String,
      required: false,
    },
  },
  computed: {
    inputId() {
      if (this.textAreaId && !this.isEmpty(this.textAreaId)) {
        return this.textAreaId;
      }
      return `textarea-add-${this.roleKind}-${this.roleType}`;
    },
    formLabel() {
      let formLabel = 'Add Role by its ID Type';
      const formattedRoleType = this.capitalize(this.roleType);
      const formattedRoleKind = this.capitalize(this.roleKind);
      if (this.roleKind === 'person') {
        formLabel = `Add ${formattedRoleKind} ${formattedRoleType} by PID or Guest ID`;
      } else if (this.roleKind === 'service') {
        formLabel = `Add ${formattedRoleKind} ${formattedRoleType} by UUSID`;
      } else if (this.roleKind === 'group') {
        formLabel = `Add ${formattedRoleKind} ${formattedRoleType} by UUGID`;
      }
      return formLabel;
    },
    errorMessage() {
      if (this.errorStart) {
        return `${this.errorStart} ${this.idMinLength} characters`;
      }
      let typePart = 'Role';
      if (this.roleKind === 'person') {
        typePart = 'PIDs/Guest';
      } else if (this.roleKind === 'service') {
        typePart = 'Service';
      } else if (this.roleKind === 'group') {
        typePart = 'Group';
      }
      return `New ${typePart} IDs must be at least ${this.idMinLength} characters.`;
    },
    showError() {
      const ids = this.formObject.ids.trim();
      return (ids.length > 0 && ids.length < 3);
    },
  },
  watch: {
    showError(hasError) {
      this.formObject.isValid = !hasError;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/form/AddRolesFormGroup.vue